import { CustomerProfile } from '@/models';
import { AccountManagementEvent } from '@/services/analytics/events';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

interface ReasonForLeaving {
    name: string;
    selected: boolean;
    reason: string;
}

@Component({
    name: 'CmgLeaveRewardsModal',
})
export default class CmgLeaveRewardsModal extends Vue {
    isLeavingRewards = false;
    formSubmissionErrorMessage = '';
    reasonsForLeaving: ReasonForLeaving[] = [
        { name: 'did-not-know-enrolled', selected: false, reason: `I didn't know I was enrolled.` },
        { name: 'account-with-different-email-address', selected: false, reason: 'I have an account with a different email address.' },
        { name: 'too-many-emails', selected: false, reason: 'I receive too many emails.' },
        { name: 'do-not-use-program-enough', selected: false, reason: `I don't use the program enough to reap the benefits.` },
        { name: 'free-food-is-not-my-thing', selected: false, reason: `Free food just isn't my thing.` },
    ];

    async mounted() {
        await this.$services.customer.waitForCustomerInitialization();

        this.initializeForm();
    }

    get visible(): boolean {
        return this.$appStore.state.ui.modals.leaveRewardsModal.visible;
    }

    get reasonForLeaving(): string {
        return this.reasonsForLeaving.find(r => r.selected)?.name ?? '';
    }

    get customer(): CustomerProfile | null {
        const profile = this.$appStore.state.customer.profile;
        return profile && !profile.isGuest ? profile : null;
    }

    initializeForm(): void {
        this.reasonsForLeaving.map(r => (r.selected = false));
        this.formSubmissionErrorMessage = '';
    }

    async onLeaveRewards(): Promise<void> {
        if (!this.reasonForLeaving) {
            this.formSubmissionErrorMessage = 'Please select a reason'
            return;
        }

        this.isLeavingRewards = true;
        this.formSubmissionErrorMessage = '';

        try {
            this.$services.reward.clearRewards();
            await this.$services.loyalty.unenrollInLoyalty(this.reasonForLeaving);
            await this.$services.customer.updateCustomer({ hasSeenRewardsGenOnboarding: false, hasSeenRewardsExchOnboarding: false });
            this.$services.customer.setProfileSubscriptionChangeOnly(true);
            await this.$services.customer.refreshCustomerProfileInfo(true, false, true);
            this.$services.adobeTarget.sendAdobeTargetExperienceRequest(this.$route.name);
            this.onLeaveclose();
        } catch (err) {
            this.formSubmissionErrorMessage = 'Error trying to leave rewards';
        }

        this.$services.analytics.send(new AccountManagementEvent('personal-preferences|leave-chipotle-rewards'));
        
        this.isLeavingRewards = false;
    }

    onLeaveclose() {
        this.initializeForm();
        this.$services.ui.setModalVisibility('leaveRewardsModal', false);
        this.$services.ui.nextFocus('join-reward-btn');
    }

    onClose() {
        this.initializeForm();
        this.$services.ui.setModalVisibility('leaveRewardsModal', false);
        this.$services.ui.focusBack();
    }

    onSelectReasonForLeaving(name: string) {
        this.reasonsForLeaving.map(r => {
            r.selected = r.name == name ? true : false;
        });
    }
}
